import React from 'react';
import { HotelTile } from './HotelTile';

interface HotelTileListProps {
  hotelTileListData: [];
}

const HotelTileList: React.FC<HotelTileListProps> = hotelTileListData => {
  return (
    <>
      <HotelTile />
      <HotelTile />
    </>
  );
};

HotelTileList.displayName = 'HotelTileList';

export { HotelTileList };
